var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1111 17.9303V21.0311C23.1123 21.319 23.0533 21.6039 22.938 21.8676C22.8227 22.1314 22.6536 22.3681 22.4414 22.5627C22.2293 22.7573 21.9789 22.9055 21.7062 22.9977C21.4335 23.0899 21.1446 23.1242 20.8579 23.0983C17.6774 22.7527 14.6222 21.6659 11.938 19.9252C9.44066 18.3382 7.32336 16.2209 5.73645 13.7236C3.98966 11.0272 2.90259 7.95719 2.56332 4.76236C2.53749 4.47654 2.57146 4.18847 2.66306 3.9165C2.75467 3.64452 2.9019 3.3946 3.09538 3.18264C3.28886 2.97069 3.52436 2.80134 3.78688 2.68538C4.0494 2.56943 4.33318 2.5094 4.62017 2.50913H7.72094C8.22255 2.5042 8.70884 2.68182 9.08917 3.00891C9.4695 3.33599 9.71792 3.79022 9.78813 4.28691C9.919 5.27923 10.1617 6.25355 10.5116 7.1913C10.6507 7.56125 10.6808 7.96331 10.5984 8.34984C10.5159 8.73636 10.3244 9.09116 10.0465 9.37218L8.73386 10.6848C10.2052 13.2725 12.3478 15.415 14.9354 16.8864L16.2481 15.5737C16.5291 15.2958 16.8839 15.1043 17.2704 15.0219C17.6569 14.9395 18.059 14.9696 18.429 15.1086C19.3667 15.4585 20.341 15.7013 21.3333 15.8321C21.8354 15.903 22.294 16.1559 22.6218 16.5427C22.9495 16.9296 23.1237 17.4234 23.1111 17.9303Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.39c5079ec64418422acc65ace8abac3b.svg";
export { ForwardRef as ReactComponent };